module.exports = __webpack_public_path__ + "static/media/github.58920cdc.svg";